

import React, { useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider
} from "@mui/material";
import CustomText, { textStyles } from "../../../../components/CustomText";
import profilecross from "../../../../assets/profilecross.svg";
// import StripeIcon from "../../../../assets/stripe.svg";
// import PaypalIcon from "../../../../assets/paypal.svg";
import stripe from "../../../../assets/Wallet/stripe.svg";
import paypal from "../../../../assets/Wallet/paypal.svg";
import receipt from "../../../../assets/Wallet/receipt.svg";
import view from "../../../../assets/Wallet/view.png"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import paid from "../../../../assets/Wallet/paid.svg";
import invited from '../../../../assets/Dashboard/invited.svg';
import request from "../../../../assets/Wallet/request.svg";
import inactive from "../../../../assets/Dashboard/inactive.svg";
import expire from "../../../../assets/expire.svg";
import process from "../../../../assets/Dashboard/process.svg";
import overdue from "../../../../assets/Dashboard/overdue.svg";
import received from "../../../../assets/Wallet/received.svg";
import pending from "../../../../assets/Wallet/pending.svg";
import down from "../../../../assets/down.svg";
import trial from "../../../../assets/Dashboard/trial.svg";
import company from "../../../../assets/company.png";
import code from "../../../../assets/code.svg";
import CustomButton from "../../../../components/CustomButton";
import active from "../../../../assets/Dashboard/active.svg";
import { useTranslation } from 'react-i18next';
import StatusDropdown from "../../../../components/StatusDropdown";
import { formatNumber } from "../../../../Utlis/formatNumber";
const WalletDetails = ({ open, onClose, selectedRow }) => {
  useEffect(() => {}, [selectedRow]);
const { t } = useTranslation();
  const status = selectedRow?.status;

  const statusIcons = {
    Active: active,
    Trial: trial,
    Invited: invited,
    Inactive: inactive,
    Requested: request,
    Overdue:overdue,
     Processing:process,
     Paid:active,
        paid:active,
     Pending:pending,
      Received:received,
      initiated:process
  
  };
  
  const statusStyles = {
    Active: { backgroundColor: '#4BCE97', color: '#164B35' },
    Trial: { backgroundColor: '#FEA362', color: '#702E00' },
    Invited: { backgroundColor: '#579DFF', color: '#09326C' },
    Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
    Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
      Paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
          paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
    Processing: { backgroundColor: '#FDD35C', color: '#7A4100' },
    
      initiated: { backgroundColor: '#FDD35C', color: '#7A4100' },
    Overdue: {backgroundColor: '#FFA26B', color: '#722800' },
     Pending: {  backgroundColor: '#F5CD47',  color: '#533F04', },
      Received: {  backgroundColor: '#4BCE97', color: '#164B35',  }
  };
  const displayStatusLabels = {
  initiated: 'Processing',
  success: 'Paid',
  failed: 'Failed',
  // Add other overrides if needed
};
  // console.log("Selected Row:", selectedRow)
  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{
    sx: {
      width: {
        xs: '100%',
        sm: 400,
        md: 500
      }
    }
  }}>
      <Box sx={{ position: 'sticky', top: 0, backgroundColor: '#E7EBEE', zIndex: 10, px: 2, py: 1, borderBottom: '1px solid #E4E6EF' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 0.2 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: '#2C384C' }}>
            ID#{selectedRow?.id || '----'}
          </CustomText>
        </Box>
      </Box>

      <Box sx={{ px:2,py:3,  backgroundColor: 'white' }}>
        <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 600, color: '#2C384C', textAlign: 'left', pb: 1 }}>
       {t('walletDetails.requestDetails')}
        </CustomText>
        <Box sx={{ border: '1px solid #E4E6EF', borderRadius: 2, p: 2, backgroundColor: '#fff',mt:2, mb: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'Center', alignItems: 'center' }}>
            
            <img src={paypal} alt="method" width={120} height={120} />
          </Box>

          {selectedRow && (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
    <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
  {t('walletDetails.payoutStatus')}
    </CustomText>

    {/* <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        px: 0.6,
        py: 0.4,
        borderRadius: "4px",
        backgroundColor: statusStyles[selectedRow.status]?.backgroundColor || '#eee',
        color: statusStyles[selectedRow.status]?.color || '#333'
      }}
    >
      <img src={statusIcons[selectedRow.status]} alt="status" style={{ width: 16 }} />
      <CustomText sx={{
        fontWeight: 600,
        fontSize: 14,
        color: statusStyles[selectedRow.status]?.color || '#333'
      }}>
        {selectedRow.status}
      </CustomText>
    </Box> */}

                                              <Box sx={{ pointerEvents: "none" }}>
      <StatusDropdown
      currentStatus={selectedRow?.status|| "pending"}
      />
    </Box>

  </Box>
)}
               <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('walletDetails.method')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.method}</CustomText>  </Box>




           

               <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
	{t('walletDetails.amount')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{formatNumber(selectedRow?.payoutAmount, true)}   </CustomText>  </Box>

               <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
	{t('walletDetails.dateTime')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right" }}>
{selectedRow?.paymentDate}</CustomText>  </Box>
        
{/*        
                       <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('walletDetails.processingTime')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
 	{t('walletDetails.businessDays')}</CustomText>  </Box> */}
      
        </Box>

   
           <Box sx={{display:"flex",alignItems:"center",gap:1}}>
                   <CustomText sx={{ ...textStyles.h1, fontSize:18, fontWeight: 600, color: "#000000",textAlign:"left" }}>
               {t('walletDetails.paymentDetails')}
                            </CustomText>
                          
                            </Box>
        <Box sx={{ border: '1px solid #E4E6EF', borderRadius: 2, p: 2,mt:2, backgroundColor: '#fff', mb: 3 }}>        
            {/* <img src=?.method === 'Paypal' ? PaypalIcon : StripeIcon} alt="method" width={40} height={40} /> */}
           <Box sx={{ display: 'flex', justifyContent: 'Center', alignItems: 'center' }}>   
            <img src={paypal} alt="method" width={120} height={120} />
          </Box>
           <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('walletDetails.method')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.method}</CustomText>  </Box>


     <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('walletDetails.paypalBatchId')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.batchId}</CustomText>  </Box>


 

<Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('managePayout.email')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.email}</CustomText>  </Box>



          {selectedRow && (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
    <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
 {t('walletDetails.payoutStatus')}
    </CustomText>

                                            <Box sx={{ pointerEvents: "none" }}>
      <StatusDropdown
      currentStatus={selectedRow?.status|| "pending"}
      />
    </Box>
  </Box>
)}

    <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
	{t('walletDetails.companyName')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.companyName}</CustomText>  </Box>

 <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
	{t('walletDetails.planName')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right" }}>
{selectedRow?.planName}</CustomText>  </Box>

 <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
	{t('walletDetails.commissionRate')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.commissionRate} </CustomText>  </Box>

 <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
	{t('walletDetails.planAmount')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.planAmount}</CustomText>  </Box>

              <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
	{t('walletDetails.amount')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{/* {selectedRow?.payoutAmount} */}
{formatNumber(selectedRow?.payoutAmount, true)}   
</CustomText>  </Box>
               <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('walletDetails.payoutDate')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right" }}>
{selectedRow?.payoutDate}</CustomText>  </Box>
           {/* <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
	{t('walletDetails.reason')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.reason}</CustomText>  </Box> */}
        
        </Box>
         {/* <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
           <Box sx={{display:"flex",alignItems:"center",gap:1}}>
                   <CustomText sx={{ ...textStyles.h1, fontSize:18, fontWeight: 600, color: "#000000",textAlign:"left" }}>
              	{t('walletDetails.receipt')}
                            </CustomText>
                            <img src={down} width={40} height={30} />
                            </Box>
                            <img src={receipt}/>
                           </Box> */}
        {/* <Box sx={{ border: '1px solid #E4E6EF', borderRadius: 2, p: 2,mt:3 ,backgroundColor: '#fff' }}>
          <Box sx={{ display: 'flex',justifyContent:"center",px:5}}>
           <img src={view} style={{width:"100%",height:"100%",objectFit:"contain"}}/>
          </Box>
          
        </Box> */}
      </Box>
    </Drawer>
  );
};

export default WalletDetails;

